package rendering

import currentPage
import ext.aspectRatio
import ext.set
import kotlinx.browser.window
import scroll.ScrollManger
import three.js.PerspectiveCamera
import util.DebugManager
import util.MouseManager
import util.availableWidth
import kotlin.math.max
import kotlin.math.sin


object CameraManager {
    private const val LERP_SPEED = 2
    private val offsetX get() = if (window.innerWidth < 800) 0 else if (window.innerWidth < 1200) 10 else 25
    private const val OFFSET_Y = -5

    private var targetX: Double = 0.0
    private var targetY: Double = 0.0

    val camera = PerspectiveCamera(fov = 30, aspect = window.aspectRatio, near = 0.1, far = 3000).apply {
        position.set(currentPage.initialCameraPosition)
    }
//    val camera = OrthographicCamera(
//        left = -window.innerWidth / 4,
//        right = window.innerWidth / 4,
//        top = window.innerHeight / 4,
//        bottom = -window.innerHeight / 4,
//        near = 0.1,
//        far = 3000
//    ).apply {
//        position.set(currentPage.initialCameraPosition)
//        lookAt(0,0,0)
//    }

    init {
        window.addEventListener("resize", {
//            camera.aspect = window.aspectRatio
            camera.updateProjectionMatrix()
        })
    }

    /**
     * Animate function; currently called only from the [ScrollManger].
     * Does a follow-the-mouse animation and looks at an offset. This offset is used to make the
     * object appear on the left of the screen on the main/scroll page.
     */
    fun animate(time: Double, dt: Double) {
        // follow-the-mouse animation
        val newTargetX = sin(time / 500) * 2 - MouseManager.normalizedMouseX * 10 + offsetX
        val newTargetY = sin(time / 750) * 2 + MouseManager.normalizedMouseY * 10 + OFFSET_Y

        targetX += (newTargetX - targetX) * dt * 0.00001 * LERP_SPEED
        targetY += (newTargetY - targetY) * dt * 0.00001 * LERP_SPEED

        camera.lookAt(targetX, targetY)
    }

    /**
     * Maybe update the camera z position based on the window width.
     */
    fun responsiveZOffset() {
        DebugManager.debug("window innerwidth ${window.innerWidth}")
        val offsetZ = max(-(availableWidth - 1920) / 10, 0)
        camera.position.z = currentPage.initialCameraPosition.z + offsetZ
    }
}